<template>
    <a-popconfirm
            v-if="props.record.status === 0"
            title="确定废弃这个状态码吗"
            ok-text="确定"
            cancel-text="取消"
            @confirm="()=>handleVoid(props.record.coupon_code)"
    >
        <a-tag color="blue" style="cursor: pointer">已创建</a-tag>
    </a-popconfirm>

    <a-tag color="green" v-if="record.status === 1">已核销</a-tag>
    <a-tag typa="error" v-if="record.status === -1">已废弃</a-tag>
</template>
<script setup>
    import {defineProps} from 'vue';

    // Props：接收图片数据
    const props = defineProps({
        record: Object
    });
    import {
        post_biogpt_admin_points_coupon_void
    } from "../../utils/bioinfo.api";
    import {jy_tip} from "@/utils/vue.tool";

    const handleVoid = (coupon_code, func)=>{
        post_biogpt_admin_points_coupon_void({coupon_code}, (res)=>{
            let {status, message} = res;
            if(status === 403) jy_tip('您没有权限');
            else if(status === 4031) jy_tip('无效兑换码');
            else if(status === 1000001) {
                jy_tip('已废弃兑换码[' + coupon_code + ']', 'success');
                func();
            }
            else jy_tip('废弃失败：' + message)

        })
    };


</script>
<style>


</style>